<template>
  <full-screen-modal :close-action="close">
    <template v-slot:content>
      <div class="plan-edit-page">
        <div class="header-container">
          <div class="icons">
            <icon class="icon" icon-name="delete" :color="buttonColor" fill @click="removePlan"/>
            <icon class="icon" icon-name="edit" :color="buttonColor" fill @click="openPlanFlow"/>
          </div>
          <div class="image-container">
            <img class="image" :src="require(`@/assets/plan-ahead/icons/${image}.svg`)"/>
          </div>
          <div class="name">{{ currentPlan.name }}</div>
        </div>
        <div class="data-section">
          <progress-bar
            class="progress-bar"
            :left-amount="currentPlan.targetAmount"
            :left-label="'היעד שלי'"
            :right-label="'שמתי בצד'"
            :right-amount="currentPlan.currentAmount"
            cashflow-category="tracking"
            grayed-out />
          <plan-status-note class="note" :text="noteText" :is-on-track="plan.isOnTrack" :textColor="textColor"/>
          <div class="bottom-section">
            <div class="deadline">עד {{ deadline }}</div>
            <div class="monthly-target-section">{{ monthlyTarget }} שח בחודש</div>
          </div>
        </div>
      </div>
    </template>
  </full-screen-modal>
</template>

<script>
import FullScreenModal from '@/base-components/FullScreenModal';
import { mapActions, mapState } from 'vuex';
import BaseUi from 'base-ui';
import ProgressBar
  // eslint-disable-next-line max-len
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/generic-components/cashflow-types/cashflow-types-base/ProgressBar';
import moneyUtils from '@/utils/money';
import moment from 'moment';
import Segment from '@/Segment';
import PlanStatusNote from './PlanStatusNote';
import PlansIconsMap from './plans-constanst';
import AddEditPlanFlow from './plans-flow/AddEditPlanFlow';

export default {
  name: 'PlanEditPage',
  components: {
    PlanStatusNote,
    FullScreenModal,
    Icon: BaseUi.Icon,
    ProgressBar,
  },
  props: {
    plan: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      buttonColor: BaseUi.Colors.riseupGray2,
    };
  },
  async created() {
    Segment.trackUserGot('PlanAhead_PlanPage_Shown');
    await this.updateCurrentPlan(this.plan);
  },
  computed: {
    ...mapState('planAhead', ['currentPlan']),
    image() {
      return PlansIconsMap[this.currentPlan.type] || 'general';
    },
    deadline() {
      return moment(this.plan.deadline).locale('he').format('MMMM YYYY');
    },
    monthlyTarget() {
      return moneyUtils.formatAmountWithFraction(this.currentPlan.monthlyTarget, 0);
    },
    textColor() {
      return this.plan.isOnTrack ? 'green' : 'red';
    },
    noteText() {
      return this.plan.isOnTrack
        ? 'נראה שהכל בכיוון הנכון'
        : 'נראה שלא תגיעו לסכום במועד שרציתם';
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal', 'closeModal']),
    ...mapActions('planAhead', ['updatePlan', 'updateCurrentPlan', 'resetCurrentPlan', 'deletePlan']),
    async editPlan() {
      await this.updatePlan();
    },
    async openPlanFlow() {
      Segment.trackUserInteraction('PlanAhead_PlanPage_Edit_Clicked');
      await this.closeModal();
      this.openModal({
        component: AddEditPlanFlow,
        props: {
          onDone: this.editPlan,
          plan: this.plan,
        },
        popupAlignment: 'full-screen',
      });
    },
    async close() {
      await this.resetCurrentPlan();
      await this.closeModal();
    },
    async removePlan() {
      Segment.trackUserInteraction('PlanAhead_PlanPage_Delete_Clicked');
      await this.deletePlan(this.plan);
      await this.close();
    },
  },
};
</script>

<style scoped lang="scss">
@import '~base-ui/src/scss/riseup-colors';

.plan-edit-page {
  width: 100%;

  .header-container {
    height: 304px;
    display: flex;
    flex-direction: column;
    padding: 18px 25px 30px;
    margin-bottom: 15px;
    background: $riseup_gray_disabled;

    .image-container {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
    }

    .image {
      height: 130px;
    }

    .icons {
      display: flex;
      align-self: end;
      .icon {
        font-size: 20px;
        cursor: pointer;
        margin-right: 6px;
      }
    }

    .name {
      display: flex;
      font-weight: bold;
      font-size: 24px;
    }
  }

  .data-section {
    margin: 0 25px;
  }

  .note {
    padding-top: 10px;
    padding-bottom: 24px;
  }

  .bottom-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .monthly-target-section {
      color: $riseup_gray_2;
      padding-top: 5px;
    }
  }
}

</style>
